import PropTypes from 'prop-types';
import BaseStaffInfoField from './BaseStaffInfoField';
import StaffInfoInputs from './StaffInfoInputs';
import StaffInfoInputsAddMore from './StaffInfoInputsAddMore';

FormStaffAccessInfoField.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
  toggleFieldName: PropTypes.string,
  toggleLabel: PropTypes.string,
  showToggle: PropTypes.bool,
  allowMultiple: PropTypes.bool,
};

export default function FormStaffAccessInfoField({
  fieldName,
  focusedField,
  setFocusedField,
  fieldAttributes,
  toggleFieldName,
  toggleLabel = 'Transferable',
  showToggle = true,
  allowMultiple = false,
}) {
  return (
    <BaseStaffInfoField
      fieldName={fieldName}
      fieldAttributes={fieldAttributes}
      toggleFieldName={toggleFieldName}
      toggleLabel={toggleLabel}
      showToggle={showToggle}
      showModal={false}
      disableFieldsWhenToggleOn={false}
      getInputRootFieldNames={() => [fieldName]}
    >
      {({ isEditable }) =>
        allowMultiple ? (
          <StaffInfoInputsAddMore
            fieldName={fieldName}
            focusedField={focusedField}
            setFocusedField={setFocusedField}
            fieldAttributes={fieldAttributes}
            isEditable={isEditable}
          />
        ) : (
          <StaffInfoInputs
            fieldName={fieldName}
            focusedField={focusedField}
            setFocusedField={setFocusedField}
            fieldAttributes={fieldAttributes}
            isEditable={isEditable}
          />
        )
      }
    </BaseStaffInfoField>
  );
}
